import { COUNTDOWN } from "@/constants";
import { urlSetter } from "@/counterSlice";
import { useAppSelector } from "@/hooks";
import { Box, Heading, Spinner, Text, useColorMode } from "@chakra-ui/react";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import { BiPause, BiPlay } from "react-icons/bi";
import { useDispatch } from "react-redux";
import { useAudioPlayer } from "react-use-audio-player";

interface PlayBoxProps {
  card: {
    title: string;
    uuid: string;
    preview_length: number | null;
  };
  collection: boolean;
}

export default function PlayBox({ card, collection }: PlayBoxProps) {
  const dispatch = useDispatch();
  const cardPlaying = useAppSelector((state) => state.nowplaying.card);
  const { colorMode } = useColorMode();
  const { togglePlayPause, ready, loading, playing } = useAudioPlayer();

  const handlePlayback = () => {
    if (cardPlaying.uuid != card.uuid) {
      dispatch(
        urlSetter({
          ...card,
          inCollection: collection,
          preview_length: card.preview_length,
        }),
      );
    } else {
      togglePlayPause();
    }
  };

  // const handleComplete = () => {
  //   togglePlayPause();
  // };

  const renderTime = ({ remainingTime }: { remainingTime: number }) => {
    if (remainingTime === 0) {
      return <div className="timer">Too lale...</div>;
    }

    return (
      <div>
        <Text fontSize={10}>{remainingTime}</Text>
      </div>
    );
  };

  return (
    <>
      <Box
        border="1px solid #ccc"
        borderRadius={10}
        p={3}
        display="flex"
        alignItems="center"
        style={{ cursor: "pointer" }}
        onClick={() => handlePlayback()}
        borderColor={colorMode == "dark" ? "white" : "black"}
        borderStyle="dotted"
        w={270}
        // minH={30}
      >
        <Heading size="md" flex="1" as="h1" margin={2}>
          {card.title}
        </Heading>
        {(cardPlaying.uuid != card.uuid ||
          (cardPlaying.uuid == card.uuid && !playing && !loading)) && (
          <div style={{ background: "transparent", border: "none" }}>
            <BiPlay size={30} />
          </div>
        )}
        {cardPlaying.uuid == card.uuid &&
          playing &&
          !loading &&
          !cardPlaying.inCollection &&
          cardPlaying.preview_length && (
            <CountdownCircleTimer
              isPlaying
              duration={cardPlaying.preview_length}
              colors={["#FF99D5E6", "#FF99D5E6", "#FF99D5E6", "#FF99D5E6"]}
              colorsTime={[7, 5, 2, 0]}
              // onComplete={handleComplete}
              size={30}
              strokeWidth={3}
            >
              {renderTime}
            </CountdownCircleTimer>
          )}

        {cardPlaying.uuid == card.uuid &&
          playing &&
          !loading &&
          !cardPlaying.preview_length && (
            <div style={{ background: "transparent", border: "none" }}>
              <BiPause size={30} />
            </div>
          )}

        {cardPlaying.uuid && loading && cardPlaying.uuid == card.uuid && (
          <div style={{ justifyContent: "center", alignItems: "center" }}>
            <Spinner size={"md"} mt={1} mb={0} thickness="3px" />
          </div>
        )}
      </Box>
    </>
  );
}
